import { h } from 'preact';

const ShopOptionInput = ({ option, label, subLabel, checked, onChange }) => {
  return (
    <div class='shop-input shop-input--option flex'>
      <input
        class='shop-input__hidden hide'
        onChange={onChange}
        checked={checked}
        id={`product-option-input-${option}`}
        type='radio'
      />
      <label
        class='shop-input__label flex'
        for={`product-option-input-${option}`}
      >
        <div class='shop-input__indicator'></div>
        <div>
          <p class='shop-input__text shop-input__text--main semi-bold'>{label}</p>
          <p class='shop-input__text proxima-nova'>{subLabel}</p>
        </div>
      </label>
    </div>
  );
};

export default ShopOptionInput;
